import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LanguageDropdownComponent } from './language-dropdown.component';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';

@NgModule({
  declarations: [LanguageDropdownComponent],
  exports: [LanguageDropdownComponent],
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, MatOptionModule, MatIcon]
})
export class LanguageDropdownModule {}
